let default_state = {
  epa_id: null,
  facName: null,
  facStreet1: null,
  facCity: null,
  facCounty: null,
  facZip: null,
  facLat: null,
  facLng: null,
  windowPosition: null,
  showInfoWindow: false,
  from: null
};

export default function currentSelectionReducer(state = default_state, action) {
  if (action.type === "UPDATE_SELECTION") {
    return {
      epa_id: action.epa_id,
      facName: action.facName,
      facStreet1: action.facStreet1,
      facCity: action.facCity,
      facCounty: action.facCounty,
      facZip: action.facZip,
      facLat: action.facLat,
      facLng: action.facLng,
      windowPosition: {
        lat: action.facLat,
        lng: action.facLng
      },
      showInfoWindow: action.showInfoWindow,
      from: action.from
    };
  }
  return state;
}
